<template>

    <!--fixed header-->
    <div class="fixed xl:block lg:block md:block w-full surface-0 px-3 z-4 top-0 min-h-3">
        <div class="center flex w-full flex-column 
            xl:px-4 lg:px-4 md:px-4">
            <div class="flex flex-row w-full mt-2 mb-2">
                <div v-if="!process && step!=1" class="inline-flex align-items-center justify-content-center gap-2">
                    <Button icon="pi pi-arrow-left" 
                        class="p-button-lg w-full border-round-lg bg-transparent text-md text-600 border-none" 
                        @click="prevStep" link/>
                </div>
                <div class="flex flex-1 text-900 font-medium vertical-align-middle align-items-center">
                    <span class="text-2xl">{{ stepTile }}</span>
                </div>
                <div class="inline-flex align-items-center justify-content-center gap-2">
                    <Button icon="pi pi-times" 
                        class="p-button-lg w-full border-round-lg bg-transparent text-md text-600 border-none" 
                        @click="outPage" link/>
                </div>
            </div>
        </div>
    </div>


    <div class="center h-full w-full py-0 
        xl:my-8
        xl:pl-4 xl:pr-4 lg:pl-3 lg:pr-3">
		<div class="flex w-full h-full justify-content-center align-items-center pt-0 pb-0 xl:pt-4 xl:pb-8 lg:pt-3 lg:pb-5
            xl:h-auto">
			<div class="flex h-full flex-column w-full surface-0 pt-4 pl-3 pr-3 pb-4 xl:p-6 lg:p-5 md:p-4 xl:border-round-xl lg:border-round-xl">

                <div class="w-full xl:hidden lg:hidden md:hidden" style="height:50px;"></div>
            
                <div v-if="step==1" class="w-full h-full flex flex-column vertical-align-middle align-items-center">
                    <span style="display:none">{{ check_valid }} {{ process }}</span>
                    <span class="text-500 text-md xl:text-lg md:text-lg my-2 w-full max-w-30rem">{{ stepDescription }}</span> 
                    <form v-if="true" @submit.prevent="change_user_data(!v$.$invalid)" 
                        class="w-full max-w-30rem">
                        
                        <div class="field mt-4 mb-2">
                            <span class="text-color-secondary">{{ lang('name') }}:</span>
                            <InputText id="name" v-model="v$.name.$model" :class="{'p-invalid':v$.name.$invalid && submitted}" 
                                class='p-inputtext-lg mt-2 mb-2 w-full border-2 border-round-lg'/>
                            <small v-if="(v$.name.$invalid && submitted) || v$.name.$pending.$response" class="p-error">{{v$.name.required.$message.replace('Value', 'Name')}}</small>
                        </div>

                        <div class="field mt-2 mb-2">
                            <span class="text-color-secondary">{{ lang('fname') }}:</span>
                            <InputText id="name" v-model="v$.fname.$model" :class="{'p-invalid':v$.fname.$invalid && submitted}" 
                                class='p-inputtext-lg mt-2 mb-2 w-full border-2 border-round-lg'/>
                            <small v-if="(v$.fname.$invalid && submitted) || v$.fname.$pending.$response" class="p-error">{{v$.fname.required.$message.replace('Value', 'Name')}}</small>
                        </div>

                        <div class="field mt-2 mb-2">
                            <span class="text-color-secondary">{{ lang('tname') }}:</span>
                            <InputText id="name" v-model="v$.tname.$model" :class="{'p-invalid':v$.tname.$invalid && submitted}" 
                                class='p-inputtext-lg mt-2 mb-2 w-full border-2 border-round-lg'/>
                            <small v-if="(v$.tname.$invalid && submitted) || v$.tname.$pending.$response" class="p-error">{{v$.tname.required.$message.replace('Value', 'Name')}}</small>
                        </div>

                    </form>
                </div>

                <div v-if="step==2" class="w-full h-full flex vertical-align-top align-items-top">
                    <span class="text-500 text-md xl:text-lg md:text-lg my-2 w-full max-w-30rem">{{ stepDescription }}</span> 
                </div>

                <div v-if="step==3" class="w-full h-full flex flex-1 vertical-align-middle align-items-center">
                    <Camera @onUpload="uploadFileDoc" @onReset="resetFileDoc" :screen_size="screen_size"/>
                </div>

                <div v-if="step==4" class="w-full h-full flex vertical-align-top align-items-top">
                    <span class="text-500 text-md xl:text-lg md:text-lg my-2 w-full max-w-30rem">{{ stepDescription }}</span> 
                </div>

                <div v-if="step==5" class="w-full h-full flex flex-1 vertical-align-middle align-items-center">
                    <Camera @onUpload="uploadFilePerson" @onReset="resetFilePerson" :screen_size="screen_size"/>
                </div>

                <div v-if="step==6" class="w-full h-full flex flex-column vertical-align-top align-items-top">
                    <span class="text-500 text-md xl:text-lg md:text-lg my-2 w-full max-w-30rem">{{ stepDescription }}</span> 

                    <div class="flex flex-column w-full max-w-30rem my-2">
                        <div class="text-600 text-lg mb-2">
                            {{ lang('name') }}: <span class="text-900">{{ v$.name.$model }}</span>
                        </div>
                        <div class="text-600 text-lg mb-2">
                            {{ lang('fname') }}: <span class="text-900">{{ v$.fname.$model }}</span>
                        </div>
                        <div class="text-600 text-lg mb-2">
                            {{ lang('tname') }}: <span class="text-900">{{ v$.tname.$model }}</span>
                        </div>
                        <div class="text-600 text-lg mb-2">
                            {{ lang('pphoto') }}: <span :class="(fileDocId) ? 'text-green-400' : 'text-orange-400'">{{ (fileDocId) ? lang('loaded') : lang('notLoaded') }}</span>
                        </div>
                        <div class="text-600 text-lg mb-2">
                            {{ lang('fphoto') }}: <span :class="(filePersonId) ? 'text-green-400' : 'text-orange-400'">{{ (filePersonId) ? lang('loaded') : lang('notLoaded') }}</span>
                        </div>
                    </div>

                </div>

                <div v-if="step==7" class="w-full h-full flex vertical-align-top align-items-top">
                    <span class="text-500 text-md xl:text-lg md:text-lg my-2 w-full max-w-30rem">{{ stepDescription }}</span> 
                </div>
                
                <div class="w-full xl:hidden lg:hidden md:hidden" style="height:50px;"></div>
            </div>
		</div>
	</div>

    <!--fixed footer-->
    <div class="fixed xl:block lg:block md:block w-full surface-0 px-3 py-2 z-4 bottom-0 min-h-3">
        <div class="center flex w-full flex-column
            xl:px-4 lg:px-4 md:px-4">
            <div class="flex flex-row w-full mt-2 mb-2">
                <Button @click="nextStep" 
                :disabled="disableStep" :loading="loadingStep"
                :label="stepBtn" class="w-full border-round-xl text-lg border-none" 
                autofocus iconPos="right" size="large"
                :icon="(step!=7) ? 'pi pi-arrow-right' : 'pi'" />
                <div v-if="!isTgApp && !isPWA" class="flex xl:hidden">
                    <div style="width: 75px;"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Connect from '@/assets/js/Connect'
import Helper from '@/assets/js/Helper'
import Camera from '@/components/widgets/Camera.vue'
import { email, required, sameAs, minLength, maxLength } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core"

export default {
    name: 'verification',
    data() {
        return {
            file: null,

            step: 1,
            loadingStep: false,
            disableStep: true,
            process: false,

            name: null,
            fname: null,
            tname: null,

            fileDoc: null,
            fileDocId: null,
            filePerson: null,
            filePersonId: null,

            stepTile: null,
            stepDescription: null,
            stepBtn: null,

            v$: useVuelidate(),

            content: {
                ru: {
					success: 'Успешно',
					error: 'Ошибка',
                    sent: 'Данные отправлены',
                    notsent: 'Данные не отправлены',
					file_uploaded: 'Файл загружен',
					maximum_files: 'Максимальное количество файлов 3'
				},
				en: {
					success: 'Success',
					error: 'Error',
                    sent: 'Data sent',
                    notsent: 'Data not sent',
					file_uploaded: 'File uploaded',
					maximum_files: 'Maximum files 3'
				}
			},
        }
    },
    methods: {
        async uploadFileDoc(file) {
            if(!file) return
            this.fileDoc = file
            this.step = 3
            this.disableStep = false             
        },
        async resetFileDoc() {
            this.fileDoc = null
            this.disableStep = true
        },
        async uploadFilePerson(file) {
            if(!file) return
            this.filePerson = file
            this.step = 5
            this.disableStep = false
        },
        async sendFileDoc() {
            this.loadingStep = true
            const upload = await this.uploadFile(this.fileDoc).then(res => res)
            if(upload.result && upload.data && upload.data.length > 0) {
                this.loadingStep = false
                this.disableStep = false
                this.fileDocId = (upload.data[0]._id) ? upload.data[0]._id : null
                return true
            } else {
                this.loadingStep = false
                return false
            }
        },
        async resetFilePerson() {
            this.filePerson = null
            this.disableStep = true
        },
        async sendFilePerson() {
            this.loadingStep = true
            const upload = await this.uploadFile(this.filePerson).then(res => res)
            if(upload.result && upload.data && upload.data.length > 0) {
                this.loadingStep = false
                this.disableStep = false
                this.filePersonId = (upload.data[0]._id) ? upload.data[0]._id : null
                return true
            } else {
                this.loadingStep = false
                return false
            }
        },
        async nextStep() {
            switch (this.step) {
                case 1:
                    if(this.check_valid) this.step++
                    break;
                case 2:
                    this.step++
                    break;
                case 3:
                    let sendDoc = await this.sendFileDoc().then(res => {
                        return res
                    })
                    if(sendDoc) this.step++
                    break;
                case 4:
                    this.step++
                    break;
                case 5:
                    let sendPerson = await this.sendFilePerson().then(res => res)
                    if(sendPerson) this.step++
                    break;
                case 6:
                    let send = await this.sendMessage().then(res => res)
                    if(send) {
                        this.step++
                        this.process = true
                    }
                    break;
                case 7:
                    this.outPage()
                    break;
                default:
                    break;
            }
        },
        prevStep() {
            if(this.step<=7 || this.step>=2) this.step--
        },
        async uploadFile(file) {
			const files = [file]
			if (files.length <= 0) return
			if (files.length > 3) {
				this.showMess('error', this.content[this.lang_].error, this.content[this.lang_].maximum_files)
				return { result: false, errors: this.content[this.lang_].maximum_files }
			}
			const formData = new FormData()

			for (let i = 0; i < files.length; i++) {
				formData.append("files", files[i], files[i].name)
			}

			const upload = await this.connect.sendFiles(formData).then(res => res)
			if (upload.result && upload.data) {
				this.showMess('success', this.content[this.lang_].success, this.content[this.lang_].file_uploaded)
                return { result: true, data: upload.data}
			} else {
				if(upload.errors && deals.errors.length > 0 ){
                    for (let i = 0; i < deals.errors.length; i++) {
                        this.showMess('error', this.content[this.lang_].error, deals.errors[i])
                    }
                }
                return { result: false, errors: (upload.errors) ? upload.errors : null}
			}
		},
        async sendMessage() {
            const message = {
                name: this.name,
                fname: this.fname,
                tname: this.tname
            }
            const from = 'verification'

            const files_arr_id = []
            if(this.fileDocId) files_arr_id.push(this.fileDocId)
            if(this.filePersonId) files_arr_id.push(this.filePersonId)

            const send = await this.connect.sendMessage(message, from, files_arr_id).then(res => res)
            if(send.result) {
                this.showMess('success', this.content[this.lang_].success, this.content[this.lang_].sent)
                return true
            } else {
                this.showMess('error', this.content[this.lang_].error, this.content[this.lang_].notsent)
                return false
            }
        },
        outPage() {
            this.$router.push({
                path: '/'
            })
        },
        showMess(severity, summary, detail) {
            this.$toast.add({ severity: severity, summary: summary, detail: detail, life: 1000 });
        },
        lang(value){
            return this.$t(`views.verify.${value}`)
        },
    },
    watch: {
        step(step) {
            if(step==1){
                if(this.check_valid) this.disableStep = false
                else this.disableStep = true
            }
            else if(step==3 || step==5) this.disableStep = true
            else this.disableStep = false

            const langTitle = `stepTitle${step}`
            const langDescription = `stepDescription${step}`

            this.stepTile = this.lang(langTitle)
            this.stepDescription = this.lang(langDescription)

            if(step==3 || step==5 || step==6) this.stepBtn = this.lang('stepBtnSend')
            else this.stepBtn = this.lang('stepBtnNext')
        },
    },
    computed: {
        lang_() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
        isDarkTheme() { return this.$store.getters.StateDarkTheme },
        screen_size() { return this.$store.getters.StateScreenSize },
        isTgApp: function () { return this.$store.getters.StateTgApp },
        isPWA: function () { return this.$store.getters.StatePWA },
        check_valid(){
            if(!this.v$) return false
            if(this.v$.name.$invalid) return false
            if(this.v$.fname.$invalid) return false
            if(this.v$.tname.$invalid) return false
            this.disableStep = false
            return true
        }
    },
    validations() {
        return {
            name: {
                required,
                minimunLength: minLength(2),
                maxLength: maxLength(30),
            },
            fname: {
                required,
                minimunLength: minLength(2),
                maxLength: maxLength(30),
            },
            tname: {
                
            }
        }
    },
    components: {
        Camera
    },
    beforeCreate() {
        this.connect = new Connect()
        this.helper = new Helper()
    },
    mounted() {
        this.stepTile = this.lang('stepTitle1')
        this.stepDescription = this.lang('stepDescription1')
        this.stepBtn = this.lang('stepBtnNext')
    }
}
</script>